import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromGeolocation from './+state/geolocation.reducer'
import { GeolocationEffects } from './+state/geolocation.effects'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromGeolocation.GEOLOCATION_FEATURE_KEY, fromGeolocation.geolocationReducer),
    EffectsModule.forFeature([GeolocationEffects]),
  ],
})
export class GbDashboardSharedDataAccessGeoLocationModule {}
